<div class="checkbox-grid__cell">
  @if (isReadOnly.value === false && !item.altCheckbox) {
    <input
      (click)="handleClick($event)"
      class="form-control form-control--checkbox"
      type="checkbox"
      [value]="item.value"
      [attr.checked]="item.value ? 'checked' : null"
    />
  }

  @if (isReadOnly.value === true) {
    <div>
      <div>
        @switch (isReadOnly.type) {
          @case ('icon') {
            @if (item.value) {
              <icon [name]="isReadOnly.label" [config]="{ type: 'pointer' }">
              </icon>
            }
          }
          @case ('text') {
            <p>{{ isReadOnly.label }}</p>
          }
        }
      </div>
    </div>
  }

  @if (item.altCheckbox && isReadOnly) {
    <div>
      <div class="checkbox-grid-cell-item__label">
        {{ item.value ? item.altCheckbox.checked : item.altCheckbox.unchecked }}
      </div>
    </div>
  }
</div>
